// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"3b4bceb4","213":"007ea6e6","305":"e620c3b6","481":"8fd82acf","725":"c6f9cd88","950":"77640b72","992":"3badbac1"}[chunkId] + ".chunk.js";
};